module.exports = __webpack_public_path__ + "img/angle-left.ca485fde.svg";